import { globalConfig } from '@/config/globalConfig';
import React, { createContext, useContext, useState } from 'react';

interface GlobalContextProps {
  enableOptionSetTranslation: boolean;
  setEnableOptionSetTranslation: (value: boolean) => void;
  googleTranslateOnlyEmptyTranslations: boolean;
  setGoogleTranslateOnlyEmptyTranslations: (value: boolean) => void;
}

const GlobalContext = createContext<GlobalContextProps | undefined>(undefined);

export const GlobalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [enableOptionSetTranslation, setEnableOptionSetTranslation] =
    useState<boolean>(globalConfig.enableOptionSetTranslation);

  const [
    googleTranslateOnlyEmptyTranslations,
    setGoogleTranslateOnlyEmptyTranslations,
  ] = useState<boolean>(globalConfig.googleTranslateOnlyEmptyTranslations);

  return (
    <GlobalContext.Provider
      value={{
        enableOptionSetTranslation,
        setEnableOptionSetTranslation,
        googleTranslateOnlyEmptyTranslations,
        setGoogleTranslateOnlyEmptyTranslations,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = (): GlobalContextProps => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobalContext must be used within a GlobalProvider');
  }
  return context;
};
